import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportFilterModel } from 'src/app/core/models/ReportFilterModel';
import { ReportModel } from 'src/app/core/models/ReportModel';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };

  constructor(private baseService: BaseService) { }
  
  generateReport(model: ReportFilterModel):  Observable<ReportModel[]> {
    
    return this.baseService.post<ReportModel[]>('Report/GenerateReport', JSON.stringify(model), this.options);
  }
}
